/* ========================================
   Custom Section — Image + Text
   Image with title and description, layout left/right
   ======================================== */

window.sectionRenderers = window.sectionRenderers || {};

window.sectionRenderers.imageText = function(data) {
  const hasImage = !!data.imageUrl;
  const hasText = !!(data.title || data.description);
  if (!hasImage && !hasText) return '';

  const layoutClass = data.layout === 'left' ? 'cs-media-text--left' : 'cs-media-text--right';
  const mediaHtml = hasImage ?
    '<div class="cs-media-text__media">' +
      '<img src="' + escapeHtml(data.imageUrl) + '" alt="" loading="lazy">' +
    '</div>' : '';
  const contentHtml = hasText ?
    '<div class="cs-media-text__content">' +
      (data.title ? '<h3 class="cs-media-text__title">' + escapeHtml(data.title) + '</h3>' : '') +
      (data.description ? '<p class="cs-media-text__description">' + escapeHtml(data.description) + '</p>' : '') +
    '</div>' : '';

  const inner = data.layout === 'left' ? mediaHtml + contentHtml : contentHtml + mediaHtml;
  return '<div class="cs-media-text ' + layoutClass + '">' + inner + '</div>';
};
